module.exports = __webpack_public_path__ + "img/dowjones_s.ae1d19a1.png";